/* eslint-disable react/no-unescaped-entities */
import { AppStyles } from '../../../assets/styles/AppStyles'
import { useNavigate } from 'react-router-dom'
import { useTheme } from '../../../utils/ThemeColorContext'
import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import Clearscore from '../../../assets/images/clearscore.svg'
import PrimaryButton from '../../../components/buttons/PrimaryButton'
import SpinnerLarge from '../../../components/SpinnerLarge'
import {
  BankNoteIcon,
  ClockIcon,
  CreditReportIcon,
  InfoIcon,
  ChatIcon,
  ListIcon,
} from '../../../assets/AppIcons'
import Image1 from '../../../assets/images/Image.png'
import StepChange from '../../../assets/images/stepchange_logo_svg.svg'
import MoneyHelper from '../../../assets/images/moneyhelper_logo_svg.svg'
import Modal from '../../../components/Modal'

import { conversionAPI } from '../../../redux/Actions/postMethods'
import React from 'react'
import DefaultPage from '../DefaultPage'
/* import manageLoanIcon from '../../../assets/icons/manageLoan2.png'
import manageLoanIconMobile from '../../../assets/icons/ManageLoanMobile.svg' */
import CheckInformationWrapper from '../CheckInformationWrapper'
import { getApplications, getReApply } from '../../../redux/Actions/getMethods'
/* import iosIcon from '../../../assets/images/Ios.png'
import AndroidIcon from '../../../assets/images/AndroidIcon.png' */
import { getAnalytics, logEvent } from 'firebase/analytics'
import OutllineButton from '../../../components/buttons/OutllineButton'
import TagManager from 'react-gtm-module'

function FailedOffer() {
  const dispatch = useDispatch()
  const { getApplication, reApply, loadingWholeScreen } = useSelector(
    (state) => state.dataReducer,
  )
  const { token } = useSelector((state) => state.authReducer)

  const navigate = useNavigate()
  const { color, isSmallScreen } = useTheme()

  const [isGetHelpModalOpen, setIsGetHelpModalOpen] = useState(false)

  useEffect(() => {
    dispatch(getReApply())
    if (getApplication[0]?.status === 'DECLINED') {
      navigate('/partner-offer')
    } else if (getApplication[0]?.status === 'REFERRED') {
      navigate('/loanreferred')
    } else if (
      getApplication[0]?.status === 'APPROVED' &&
      getApplication[0]?.offer_type === 'UPDRAFT_CREDIT_INTEREST_ONLY'
    ) {
      navigate('/loanapproved')
    } else if (
      getApplication[0]?.status === 'APPROVED' &&
      getApplication[0]?.offer_type !== 'UPDRAFT_CREDIT_INTEREST_ONLY'
    ) {
      navigate('/loanapprovedfee')
    } else {
      navigate('/address-detail')
    }
    // else if (!bank) {
    //   navigate('/verify-income')
    // }
  }, [getApplication[0]?.id])

  // Define the provided date
  const providedDate = new Date(reApply)

  // Get the current date
  const currentDate = new Date()

  // Calculate the difference in milliseconds
  const differenceInMilliseconds =
    providedDate.getTime() - currentDate.getTime()

  // Convert milliseconds to days
  const differenceInDays = Math.floor(
    differenceInMilliseconds / (1000 * 60 * 60 * 24),
  )

  const analytics = getAnalytics()
  useEffect(() => {
    if (getApplication[0]?.id && getApplication[0]?.status === 'DECLINED' && localStorage.getItem(`declinedEventSent_${getApplication[0]?.id}`) !== 'true') {
      const eventReference = 'disqualified_' // event ref replacement for 'decline_loan_application_'
      const eventName = 'Disqualified' // event name replacement for 'Decline Loan Application'
      if (window.fbq) {
        window.fbq('trackCustom', eventName,
        {
          /* applicationId: getApplication[0]?.id, */
        },
        {eventID: `${eventReference}${getApplication[0]?.id}`}
        )
        const eventReference2 = 'disqualified2_'  // event ref replacement for 'decline_loan_application_'
        const eventName2 = 'Disqualified2' // event name replacement for 'Decline Loan Application'
        window.fbq('trackCustom', eventName2,
          {},
          {eventID: `${eventReference2}${getApplication[0]?.id}`}
        )
      }
      dispatch(
        conversionAPI({
          eventName: eventName,
          eventSourceUrl: `${process.env.REACT_APP_FRONTEND_URL}partner-offer`,
          phoneNumber: token?.phone_number,
          email: token?.email,
          fName: token?.given_name,
          lName: token?.family_name,
          cognitoUserId: token?.sub,
          customData: {
            /* applicationId: getApplication[0]?.id, */
          },
          dateOfBirth: token?.birthdate,
          userAgent: navigator.userAgent,
          eventId: `${eventReference}${getApplication[0]?.id}`,
          eventReference: eventReference,
        }),
      )
      if (window.ttq) {
        const ttEventReference = 'decline_loan_application_'
        const ttEventName = 'Contact'
        window.ttq.track(ttEventName, {
          "contents": [
            {
              "content_id": getApplication[0]?.id,
            }
          ],
        }, {
          "event_id": `${ttEventReference}${getApplication[0]?.id}`
        });
      }
      if (window.snaptr) {
        window.snaptr('track', 'CUSTOM_EVENT_4', {
          transaction_id: getApplication[0]?.id,
          user_email: token?.email,
          user_phone_number: token?.phone_number,
        })
      }
      if (window.gtag) {
        window.gtag('event', 'conversion', {
          send_to: process.env.REACT_APP_LOAN_DECLINED_GTAG_CONVERSION,
          user_data: {
            email: token?.email,
            phone_number: token?.phone_number,
          },
        })
      }
      const tagManagerArgs = {
        dataLayer: {
          event: 'loan_declined',
          user_id: token?.sub,
          reason: getApplication[0]?.reason,
          status: getApplication[0]?.status,
          application: getApplication[0],
        }
      }
      TagManager.dataLayer(tagManagerArgs)
      logEvent(analytics, 'decline_loan_application_client_side', {
        platform: 'web',
      })
      localStorage.setItem(`declinedEventSent_${getApplication[0]?.id}`, 'true')
    }
  }, [getApplication[0]?.id])

  useEffect(() => {
    if (!getApplication[0]?.id) {
      dispatch(getApplications())
    }
  }, [])

  return (
    <DefaultPage>
    {loadingWholeScreen ? (
      <SpinnerLarge />
    ) : (
      <div className="h-full flex flex-col items-center justify-center space-y-10 ">
        {/* <CheckInformationWrapper img={isSmallScreen ? manageLoanIconMobile : manageLoanIcon}> */}
        <div className={"h-px"} />
        <CheckInformationWrapper img={Image1}>
          <div className="w-full space-y-8 md:space-y-10">
            <div className="flex flex-col items-center space-y-0 md:space-y-0 ">
              <h1
                style={
                  isSmallScreen
                    ? {
                        ...AppStyles.Title1,
                        color: color.Plum,
                      }
                    : {
                        ...AppStyles.LargeTitle2,
                        color: color.Plum,
                      }
                }
                className="text-center"
              >
                We{' '}
                <span
                  style={
                    isSmallScreen
                      ? { ...AppStyles.Title1, color: color.Yellow }
                      : { ...AppStyles.LargeTitle2, color: color.Yellow }
                  }
                >
                  Can’t
                </span>{' '}
                make you an offer, but here are some options...
              </h1>
              <div style={{marginTop: '24px',  marginBottom: '16px', maxWidth: '50%'}}>
                <img src={Clearscore} alt="" />
              </div>
              <p
                style={
                  isSmallScreen
                    ? {
                        ...AppStyles.Body,
                        color: color.Grey,
                        marginTop: '16px',
                        marginBottom: '24px',
                      }
                    : {
                        ...AppStyles.Body16,
                        color: color.Grey,
                        marginTop: '16px',
                        marginBottom: '24px',
                      }
                }
              >
                Our partner ClearScore may have options for you. As the UK's
                largest lending marketplace, they have over 50 UK lenders
                that they can quickly check your eligibility with, without
                impacting your credit score.
              </p>
              <div
                style={{
                  backgroundColor: color.LightGrey,
                  border: '0px',
                  //borderColor: color.MidGrey,
                  marginTop: '0px',
                  width: '100%',
                }}
                className="p-0 border rounded-2xl space-y-0 overflow-y-scroll "
              > 
                <div 
                //className="md:pl-0 flex flex-col  items-start md:justify-between space-y-0 md:flex-row md:items-start md:space-y-0 md:space-x-6 "
                >
                  <div className="md:flex flex-col space-y-0 ">
                    <div
                      style={{ margin: '16px 0 16px 16px' }}
                      className="flex items-center space-x-4 "
                    >
                      <div className="">
                        <BankNoteIcon
                          fill={color.BlurpleTeal}
                          className={'w-6 h-6'}
                        />
                      </div>
                      <p
                        className="flex items-center pt-[2px]"
                        style={
                          isSmallScreen
                            ? { ...AppStyles.Body, color: color.Grey }
                            : { ...AppStyles.Body16, color: color.Grey }
                        }
                      >
                        Compare multiple lenders
                      </p>
                    </div>
                    <div className="bg-white h-px"></div>
                    <div
                      style={{ margin: '16px 0 16px 16px' }}
                      className="flex items-center space-x-4 "
                    >
                      <ClockIcon
                        fill={color.BlurpleTeal}
                        className={'w-6 h-6'}
                      />
                      <p
                        className=" flex items-center pt-[2px]"
                        style={
                          isSmallScreen
                            ? { ...AppStyles.Body, color: color.Grey }
                            : { ...AppStyles.Body16, color: color.Grey }
                        }
                      >
                        Get a decision in minutes
                      </p>
                    </div>
                    <div className="bg-white h-px"></div>
                    <div
                      style={{ margin: '16px 0 16px 16px' }}
                      className="flex items-center space-x-4 "
                    >
                      <CreditReportIcon
                        fill={color.BlurpleTeal}
                        className={'w-6 h-6'}
                      />
                      <p
                        className="flex items-center justify-center pt-[2px]"
                        style={
                          isSmallScreen
                            ? { ...AppStyles.Body, color: color.Grey }
                            : { ...AppStyles.Body16, color: color.Grey }
                        }
                      >
                        Check eligibility with no impact on score
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="w-full ">
                <div
                  style={{
                    backgroundColor: color,
                    borderColor: color.MidGrey,
                    margin: '16px 0',
                    height: isSmallScreen && '100%',
                  }}
                  className="border w-full rounded-[16px] flex p-4 space-x-4 "
                >
                  <div className="">
                    <InfoIcon fill={color.BlurpleTeal} />
                  </div>
                  <div className="flex flex-col space-y-2">
                    <b
                      style={{
                        ...AppStyles.BodyBold,
                        color: color.BlurpleTeal,
                      }}
                    >
                      How does it work?
                    </b>
                    <p
                      style={{
                        ...AppStyles.Body12Demi,
                        color: color.Grey,
                        width: isSmallScreen && '100%',
                        lineHeight: isSmallScreen && '20px',
                        height: isSmallScreen && '100%',
                      }}
                      className="leading-[20px]"
                    >
                      You will be redirected to our partner’s site, where you
                      can submit your details to check your eligibility. Once
                      you’ve entered your information, they may contact you
                      directly by phone or email to provide customer support.
                      <br/>
                      <br/>
                      By acting as a credit broker, Updraft will receive a
                      commission if you successfully complete a partner
                      application.
                      <br/>
                      <br/>
                      ClearScore{' '}
                      <a
                        href="https://www.clearscore.com/terms"
                        target="_blank"
                        rel="noreferrer"
                        style={{
                          ...AppStyles.Body12Demi,
                          color: color.BlurpleWhite,
                        }}
                      >
                        Terms & Conditions
                      </a> {' '}&{' '}
                      <a
                        href="https://www.clearscore.com/privacy-policy"
                        target="_blank"
                        rel="noreferrer"
                        style={{
                          ...AppStyles.Body12Demi,
                          color: color.BlurpleWhite,
                        }}
                      >
                        Privacy Policy
                      </a>
                      {' '}
                    </p>
                  </div>
                </div>
              </div>
              { !isSmallScreen && (
                <div
                  style={{
                    marginTop: '0px',
                  }}
                  className={"w-full px-6 pb-6 md:p-0 fixed bottom-0 md:relative  w-full "}
                >
                  {isSmallScreen && (
                    <>
                      <div
                        className="absolute inset-x-0 top-[-32px] h-[25px] bg-gradient-to-t from-[#F5F7FC] to-[#F5F7FC00] pointer-events-none"
                      ></div>
                      <div
                        className="absolute inset-x-0 top-[-8px] h-[8px] bg-[#F5F7FC] pointer-events-none"
                      />
                    </>
                  )}
                  <div className="flex flex-col items-center space-y-2 mb-8">
                    <PrimaryButton
                      id={'clearscore-btn'}
                      text={'Take me to ClearScore'}
                      onClick={() => {
                        window.open('https://eligibility-check.clearscore.com/?advsrcSuggest=UPDRFTDWB&source=UPDRFTDWB', '_self')
                      }}
                    />
                    <OutllineButton
                      id={'get-help-btn'}
                      text={'Get help with debt'}
                      onClick={() => {
                        setIsGetHelpModalOpen(true)
                      }}
                      className={' w-full'}
                    />
                  </div>
                </div>
              )}
            </div>
          </div>
          <div className="flex flex-col w-full space-y-0 items-center">
            {/* <img
              src={isSmallScreen ? manageLoanIconMobile : manageLoanIcon}
              alt=""
              style={{
                width: isSmallScreen ? '168px' : '235.29px',
                height: isSmallScreen ? '200px' : '280px',
                objectFit: 'contain',
                marginBottom: isSmallScreen ? '16px' : '16px',
              }}
            /> */}
            <div className="flex flex-col w-full items-center space-y-6">
              {/* <h1
                style={
                  isSmallScreen
                    ? {
                        ...AppStyles.Title1,
                        color: color.Plum,
                        height: !isSmallScreen && '32px',
                        width: '279px',
                      }
                    : { ...AppStyles.LargeTitle2, color: color.Plum }
                }
                className=" text-center"
              >
                Sorry, {profile?.first_name}
              </h1>
              <h1
                style={
                  isSmallScreen
                    ? {
                        ...AppStyles.Title1,
                        color: color.BlurpleTeal,
                        height: !isSmallScreen && '32px',
                        width: '279px',
                      }
                    : { ...AppStyles.LargeTitle2, color: color.BlurpleTeal }
                }
                className=" text-center"
              >
                Unfortunately we can’t offer you Updraft Credit at this time.
                But...
              </h1> */}
              {/* <h1
                style={{
                  fontSize: isSmallScreen ? '18px' : '20px',
                  fontFamily: 'GilroyBold',
                  lineHeight: '32px',
                  color: '#5D1CD3',
                  width: '376px',
                }}
                className=" text-center"
              >
                {isSmallScreen
                  ? 'You can get the Updraft app'
                  : 'Scan the QR code above to install Updraft on your phone.'}
              </h1>
              <p
                style={
                  isSmallScreen
                    ? {
                        ...AppStyles.Body,
                        color: color.Grey,
                        margin: 0,
                        marginTop: '16px',
                      }
                    : {
                        fontSize: '16px',
                        fontWeight: '500',
                        lineHeight: '28px',
                        color: '#6C819C',
                        fontFamily: 'MaisonMedium","sans-serif',
                      }
                }
                className="leading-[24px] text-center"
              >
                {!isSmallScreen
                  ? 'You can get your free credit score and report, alongside the ability to manage your spending in one place on our free app.'
                  : 'Enjoy your free credit score and report, alongside the ability to manage your spending in one place.'}
              </p> */}
              <div
                className="flex justify-center w-full rounded-[12px]"
                style={
                  isSmallScreen
                    ? {
                        background: 'rgba(93, 28, 211, 0.05)',
                        padding: '20px 16px 16px 16px',
                        marginBottom: '40px',
                      }
                    : {
                        background: 'rgba(42, 24, 76, 0.05)',
                        padding: '20px 16px 16px 16px',
                      }
                }
              >
                <span className="reapplyin"> You can reapply with Updraft in</span>
                <span className="days_90">
                  {reApply ? differenceInDays || '-' : '-'} days
                </span>
              </div>

              {/* <p
                style={{
                  ...AppStyles.Caption4,
                  color: '#6C819C',
                }}
              >
                Available On
              </p>
              <div className="flex md:justify-between md:w-[77px] m-[auto]">
                { isSmallScreen ? (
                  <>
                    <a
                      href={isSmallScreen ? "https://updraft.onelink.me/ZLOh/oorc3pwo" : "https://updraft.onelink.me/ZLOh/moxsc062" }
                      target="_blank"
                      className="cursor-pointer w-full space-y-2 "
                      rel="noreferrer"
                    >
                      <img
                        src={iosIcon}
                        style={{
                          width: '32px',
                          height: '25px',
                          objectFit: 'contain',
                        }}
                      />
                    </a>
                    <a
                      href={isSmallScreen ? "https://updraft.onelink.me/ZLOh/oorc3pwo" : "https://updraft.onelink.me/ZLOh/moxsc062" }
                      target="_blank"
                      className="cursor-pointer w-full space-y-2 "
                      rel="noreferrer"
                    >
                      <img
                        src={AndroidIcon}
                        style={{
                          width: '32px',
                          height: '25px',
                          objectFit: 'contain',
                        }}
                      />
                    </a>
                  </>
                ) : (
                  <>
                    <div className="w-full space-y-2 ">
                      <img
                        src={iosIcon}
                        style={{
                          width: '32px',
                          height: '25px',
                          objectFit: 'contain',
                        }}
                      />
                    </div>
                    <div className="w-full space-y-2 ">
                      <img
                        src={AndroidIcon}
                        style={{
                          width: '32px',
                          height: '25px',
                          objectFit: 'contain',
                        }}
                      />
                    </div>
                  </>
                )}
              </div> */}
              <div className="h-px"/>
            </div>
          </div>
        </CheckInformationWrapper>
        { isSmallScreen && (
          <div
            style={{
              marginTop: isSmallScreen && '24px',
              background: !isSmallScreen && 'linear-gradient(0deg, #F5F7FC 0%, rgba(245, 247, 252, 0) 100%)',
            }}
            className={
              isSmallScreen ? (
                `mt-10 md:max-w-[588px] m-[auto] fixed w-full bottom-0 px-6 pb-6 md:p-0 flex flex-col-reverse gap-5 md:gap-10 md:flex-row bg-[#F5F7FC]`
              ) : (
                `px-6 pb-6 md:p-0 fixed bottom-0 md:relative  w-full `
              )
            }
          >
            {isSmallScreen && (
              <>
                <div
                  className="absolute inset-x-0 top-[-32px] h-[25px] bg-gradient-to-t from-[#F5F7FC] to-[#F5F7FC00] pointer-events-none"
                ></div>
                <div
                  className="absolute inset-x-0 top-[-8px] h-[8px] bg-[#F5F7FC] pointer-events-none"
                />
              </>
            )}
            <div className="flex flex-col items-center space-y-2 mb-8">
              <PrimaryButton
                id={'clearscore-btn'}
                text={'Take me to ClearScore'}
                onClick={() => {
                  window.open('https://eligibility-check.clearscore.com/?advsrcSuggest=UPDRFTDWB&source=UPDRFTDWB', '_blank')
                }}
                className={' md:w-[456px] '}
              />
              <OutllineButton
                id={'get-help-btn'}
                text={'Get help with debt'}
                onClick={() => {
                  setIsGetHelpModalOpen(true)
                }}
                className={' w-full'}
              />
            </div>
          </div>
        )}
      </div>
    )}
    <Modal isOpen={isGetHelpModalOpen} onClose={() => setIsGetHelpModalOpen(false)}>
        <div className=" space-y-6">
          <h1
            style={{
              ...AppStyles.LargeTitle3,
              color: color.Plum,
            }}
            className="text-center "
          >
            Need help managing your debt?
          </h1>
          <p
            style={
              {
                ...AppStyles.BodyRandomlyDifferent,
                color: color.Grey,
              }
            }
            className="text-center"
          >
            If you need any help with your money at this time there are two organisations we'd recommend speaking with;
            both are impartial organisations who can chat through any money worries or concerns and give guidance on
            what to do next.
          </p>
          <div 
            //className="md:pl-0 flex flex-col  items-start md:justify-between space-y-0 md:flex-row md:items-start md:space-y-0 md:space-x-6 "
          >
            <div
              style={{
                backgroundColor: color.LightGrey,
                border: '0px',
                //borderColor: color.MidGrey,
                marginTop: '0px',
                width: '100%',
              }}
              className="p-0 border rounded-2xl space-y-0 overflow-y-scroll "
            > 
              <div className="md:flex flex-col space-y-0 ">
                <div
                  style={{ margin: '16px 16px 16px 16px' }}
                  className="flex items-center justify-around "
                >
                  <div style={{marginTop: '0px',  marginBottom: '0px',}}>
                    <img src={StepChange} alt="StepChange" />
                  </div>
                  <div style={{marginTop: '0px',  marginBottom: '0px',}}>
                    <img src={MoneyHelper} alt="MoneyHelper" />
                  </div>
                </div>
                <div className="bg-white h-px"></div>
                <div
                  style={{ margin: '16px' }}
                  className="flex items-center space-x-4 "
                >
                  <div className="">
                    <ChatIcon
                      fill={color.BlurpleTeal}
                      className={'w-6 h-6'}
                    />
                  </div>
                  <p
                    className="flex items-center pt-[2px]"
                    style={
                      isSmallScreen
                        ? { ...AppStyles.Body, color: color.Grey }
                        : { ...AppStyles.Body16, color: color.Grey }
                    }
                  >
                    Get debt advice
                  </p>
                </div>
                <div className="bg-white h-px"></div>
                <div
                  style={{ margin: '16px' }}
                  className="flex items-center space-x-4 "
                >
                  <ClockIcon
                    fill={color.BlurpleTeal}
                    className={'w-6 h-6'}
                  />
                  <p
                    className=" flex items-center pt-[2px]"
                    style={
                      isSmallScreen
                        ? { ...AppStyles.Body, color: color.Grey }
                        : { ...AppStyles.Body16, color: color.Grey }
                    }
                  >
                    Take things at your own pace
                  </p>
                </div>
                <div className="bg-white h-px"></div>
                <div
                  style={{ margin: '16px' }}
                  className="flex items-center space-x-4 "
                >
                  <ListIcon
                    fill={color.BlurpleTeal}
                    className={'w-6 h-6'}
                  />
                  <p
                    className="flex items-center justify-center pt-[2px]"
                    style={
                      isSmallScreen
                        ? { ...AppStyles.Body, color: color.Grey }
                        : { ...AppStyles.Body16, color: color.Grey }
                    }
                  >
                    A plan to deal with your debt
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className=" space-y-2 mb-8">
            <PrimaryButton
              id={'go-to-debt-management-btn'}
              text={'View debt management options'}
              onClick={() => {
                window.open('https://www.updraft.com/debt-management/', '_self')
              }}
            />
          </div>
        </div>
      </Modal>
    </DefaultPage>
  )
}

export default FailedOffer
